// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type GetPathwaysForCampaignShareActionQueryVariables = PrivateSchemaTypes.Exact<{
  campaignId: PrivateSchemaTypes.Scalars['PositiveInt'];
  actionId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type GetPathwaysForCampaignShareActionQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { campaign?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CampaignModelAsAdminQueries' }
      & Pick<PrivateSchemaTypes.CampaignModelAsAdminQueries, 'id'>
      & { pathwayShareAction?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'CampaignPathwayShareActionModelAsEditor' }
        & { actionPathways: Array<(
          { __typename?: 'CampaignActionPathwayModel' }
          & { pathway: (
            { __typename?: 'PathwayModelAsAdmin' }
            & Pick<PrivateSchemaTypes.PathwayModelAsAdmin, 'id' | 'title' | 'deleted_at' | 'published_date'>
          ) }
        )> }
      )> }
    )> }
  )> }
);

export type GetPathwaysByIdsQueryVariables = PrivateSchemaTypes.Exact<{
  ids: PrivateSchemaTypes.Scalars['JSON'];
}>;


export type GetPathwaysByIdsQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { organisation?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'OrganisationModelAsAdminQueries' }
      & Pick<PrivateSchemaTypes.OrganisationModelAsAdminQueries, 'id'>
      & { pathways: Array<(
        { __typename?: 'PathwayModelAsAdmin' }
        & Pick<PrivateSchemaTypes.PathwayModelAsAdmin, 'id' | 'title' | 'deleted_at' | 'published_date'>
      )> }
    )> }
  )> }
);


export const GetPathwaysForCampaignShareActionDocument = gql`
    query getPathwaysForCampaignShareAction($campaignId: PositiveInt!, $actionId: PositiveInt!) {
  admin {
    campaign(id: $campaignId) {
      id
      pathwayShareAction(id: $actionId) {
        actionPathways {
          pathway {
            id
            title
            deleted_at
            published_date
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPathwaysForCampaignShareActionQuery__
 *
 * To run a query within a React component, call `useGetPathwaysForCampaignShareActionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPathwaysForCampaignShareActionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPathwaysForCampaignShareActionQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      actionId: // value for 'actionId'
 *   },
 * });
 */
export function useGetPathwaysForCampaignShareActionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPathwaysForCampaignShareActionQuery, GetPathwaysForCampaignShareActionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPathwaysForCampaignShareActionQuery, GetPathwaysForCampaignShareActionQueryVariables>(GetPathwaysForCampaignShareActionDocument, options);
      }
export function useGetPathwaysForCampaignShareActionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPathwaysForCampaignShareActionQuery, GetPathwaysForCampaignShareActionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPathwaysForCampaignShareActionQuery, GetPathwaysForCampaignShareActionQueryVariables>(GetPathwaysForCampaignShareActionDocument, options);
        }
export type GetPathwaysForCampaignShareActionQueryHookResult = ReturnType<typeof useGetPathwaysForCampaignShareActionQuery>;
export type GetPathwaysForCampaignShareActionLazyQueryHookResult = ReturnType<typeof useGetPathwaysForCampaignShareActionLazyQuery>;
export type GetPathwaysForCampaignShareActionQueryResult = Apollo.QueryResult<GetPathwaysForCampaignShareActionQuery, GetPathwaysForCampaignShareActionQueryVariables>;
export const GetPathwaysByIdsDocument = gql`
    query getPathwaysByIds($ids: JSON!) {
  admin {
    organisation {
      id
      pathways(
        filters: [{name: includeDeleted, value: true}, {name: searchByIds, value: $ids}]
      ) {
        id
        title
        deleted_at
        published_date
      }
    }
  }
}
    `;

/**
 * __useGetPathwaysByIdsQuery__
 *
 * To run a query within a React component, call `useGetPathwaysByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPathwaysByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPathwaysByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetPathwaysByIdsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPathwaysByIdsQuery, GetPathwaysByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPathwaysByIdsQuery, GetPathwaysByIdsQueryVariables>(GetPathwaysByIdsDocument, options);
      }
export function useGetPathwaysByIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPathwaysByIdsQuery, GetPathwaysByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPathwaysByIdsQuery, GetPathwaysByIdsQueryVariables>(GetPathwaysByIdsDocument, options);
        }
export type GetPathwaysByIdsQueryHookResult = ReturnType<typeof useGetPathwaysByIdsQuery>;
export type GetPathwaysByIdsLazyQueryHookResult = ReturnType<typeof useGetPathwaysByIdsLazyQuery>;
export type GetPathwaysByIdsQueryResult = Apollo.QueryResult<GetPathwaysByIdsQuery, GetPathwaysByIdsQueryVariables>;